/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckOfferStatusEnum } from './deck-offer-status-enum';

/**
 * Offer serializer in deck
 */
export interface DeckOfferRequest {
  name: string;
  description: string;
  company_url?: string | null;
  banner: Blob;
  shares: number;
  added_by_id: string;
  status: DeckOfferStatusEnum;
  url?: string | null;
}
export namespace DeckOfferRequest {}
